module.exports = __webpack_public_path__ + "static/media/carrito.b23f1dd1.jpg";